<template>
    <div class="fix-search-main">
        <el-row type="flex" >
            <el-col :span="21">
                <el-row>
                    <el-col class="fix-search-item">
                        <el-input :placeholder="$translate('lang.E3202103160001', { defaultText: '企业前缀' })" @keyup.enter.native="handleLogin" v-model="queries.prefixCode"></el-input>
                    </el-col>
                    <el-col class="fix-search-item">
                        <el-input :placeholder="$translate('lang.E3202103160002', { defaultText: '企业名称' })" @keyup.enter.native="handleLogin" v-model="queries.cnName"></el-input>
                    </el-col>
                    <el-col class="fix-search-item">
                        <el-select v-model="queries.registerStatus" style="width:100%" clearable >
                            <el-option :label="$translate('lang.E3202102260004', { defaultText: '启用' })" value='Y'></el-option>
                            <el-option :label="$translate('lang.E3202102260003', { defaultText: '停用' })" value='N'></el-option>
                        </el-select>
                    </el-col>
                    <div>
                        <el-button @click="handleLogin" type="primary" size="mini" :loading="searchBlock" icon='el-icon-search'>
                            {{$translate('lang.E3202101260004', { defaultText: '查 询' })}}
                        </el-button>
                        <el-button @click="reset"  size="mini" class="sn-search-reset-button" >
                            {{$translate('lang.E3202101260009', { defaultText: '重 置' })}}
                        </el-button>
                    </div>
                </el-row>
            </el-col>
        </el-row>
    </div>
</template>
<script>
export default {
    props: ['searchBlock'],
    data() {
        return {
            queries: {
                prefixCode: '',
                cnName: '',
                registerStatus: ''
            }
        };
    },
    methods: {
        handleLogin() {
            this.$emit('closeChange', this.queries);
        },
        reset() {
            this.queries = {};
        }
    }
};
</script>
<style lang="less">
.fix-search-main{
    margin-bottom: 20px;
    .fix-search-item{
        width: 190px;
        margin-right: 10px;
    }
}
</style>